module.exports = __webpack_public_path__ + "videos/home_cn.0ca81e4.mp4";